// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__JAGXo","list":"styles_list__3yH3-"};